import React from 'react';
import PropTypes from 'prop-types';
import style from './styles';

const PremierBagErrorMessage = ({ userMessage }) => (
  <div className={ style.PremierBagError } >
      <p>
        <span className={ style.PremierBagErrorInfoIcon } aria-hidden="true">i</span>
        <span className={ style.PremierBagErrorMessage } role="alert" >{ userMessage }</span>
      </p>
  </div>
);

PremierBagErrorMessage.propTypes = {
  userMessage: PropTypes.string.isRequired,
};

export default PremierBagErrorMessage;
